import { Textarea } from "@chakra-ui/react";
import { useLayoutEffect } from "react";
import { RegisterOptions, useController } from "react-hook-form";
import { FLUSHED_FLOATING_INPUT_SX } from "definitions/constants/styling";
import { useFloatingField } from "./context";
import { sizeStyles } from "./sizeStyles";

type FloatingTextAreaProps = {
  control: any;
  name: string;
  rules?: RegisterOptions;
  defaultValue?: any;
  disabled?: boolean;
  readOnly?: boolean;
  rows?: number;
};

function FloatingTextArea({ control, name, rules, defaultValue, disabled, readOnly, rows = 4 }: FloatingTextAreaProps) {
  const { setHasValue, size } = useFloatingField();
  const { field } = useController({ control, name, rules, defaultValue });
  const styles = sizeStyles[size];

  useLayoutEffect(() => {
    setHasValue(!!field.value);
  }, [field.value, setHasValue]);

  return (
    <Textarea
      {...field}
      id={name}
      className="floating-textarea"
      placeholder=" "
      disabled={disabled}
      readOnly={readOnly}
      rows={rows}
      paddingTop={styles.textInputPaddingTop}
      fontSize={styles.fontSize}
      variant="unstyled"
      sx={FLUSHED_FLOATING_INPUT_SX}
    />
  );
}

export default FloatingTextArea;
